module.exports = __webpack_public_path__ + "img/buenas-practicas.76ae48b8.png";